import React from "react";
import { reduxForm, Field } from "redux-form";
import validate from "./validate";
import { requiredValidate, phoneNumberValidate } from "../../helpers";
import FormNavigation from "../navigation.component";
import { FormField } from "pickups-ui-library";
import { Alert } from "reactstrap";

const PhoneNumberLookup = (props) => {
  const { handleSubmit, pristine, submitting, error, previousStep } = props;

  return (
    <form onSubmit={handleSubmit}>
      <div className={"box p-4"}>
        <Field
          name="phoneNumber"
          type="phone"
          component={FormField}
          label="Phone Number"
          placeholder=""
          validate={[requiredValidate, phoneNumberValidate]}
        />
        {error && <Alert color="danger">{error}</Alert>}
      </div>
      <FormNavigation {...props} />
    </form>
  );
};

export default reduxForm({
  form: "publicPickupForm",
  destroyOnUnmount: false,
  validate,
})(PhoneNumberLookup);
